import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './common/header/header.component';
import { FooterComponent } from './common/footer/footer.component';
import { HomeComponent } from './feature/home/home.component';
import { environment } from 'src/environments/environment';
import { NotfoundComponent } from './common/notfound/notfound.component';
import { LoginComponent } from './feature/login/login.component';
import { AuthService } from './shared/services/auth.service';
import { DashboardComponent } from './feature/dashboard/dashboard.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RoiComponent } from './roi/roi.component';
import { AdvancedRoiComponent } from './advanced-roi/advanced-roi.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    RoiComponent,
    AdvancedRoiComponent,
    HomeComponent,
    NotfoundComponent,
    LoginComponent,
    DashboardComponent
    ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    NgbModule
  ],
  providers: [AuthService],
  bootstrap: [AppComponent]
})
export class AppModule { }
